<script setup>
// import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
</script>

<template>
  <!--<VueQueryDevtools />-->
  <AppHeader />
  <div class="container-fluid">
    <RouterView />
  </div>
  <AppFooter />
</template>
